import Main from '../../layout/main/main';
import styles from './terms.module.css';
const Terms = () => {
  return (
    <Main
      h="Terms of Service"
      activeIndex="4"
      className={`sm5-active-section ${styles.ctn}`}
    >
      <a
        href="https://www.zhiyun-tech.com/en/service/agreement_detail/75"
        className={`${styles.link} `}
      >
        <div className="sm5-active-fade-in-element">
        TERMS AND CONDITIONS-ZHIYUN MOBILE FILM CHALLENGE 2021
        </div>

      </a>
    </Main>
  );
};

export default Terms;
